import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  IconButton,
  Tooltip,
} from '@mui/material'
import useCustomStyles from '../../../../utils/hooks/CustomStylesHook'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#4682b4',
    borderRadius: 12,
    padding: theme.spacing(2),
    // minWidth: 300,
    // width: 'fit-content',
  },
  cardContent: {
    padding: 3,
  },
  icon: {
    width: 16,
    height: 16,
    backgroundColor: theme.palette.grey[400],
    borderRadius: '50%',
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    color: '#ffffff',
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: 27,
    fontWeight: 600,
    color: '#ffffff',
  },
  unit: {
    fontSize: 14,
    fontWeight: 400,
    color: '#ffffff',
  },
  status: {
    fontSize: 12,
    fontWeight: 400,
    marginTop: theme.spacing(0.5),
    color: '#ffffff',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subName: {
    fontSize: 16,
    fontWeight: 300,
    marginTop: theme.spacing(0.5),
    color: '#ffffff',
  },
  openBtn: {
    padding: 1,
  },
  cardIconContainer: {
    background: 'white',
  },
})

const VitalCard = ({
  name,
  subName,
  value,
  unit,
  note,
  icon,
  details,
  onClick,
  timeStamp,
}: {
  name: string
  subName: string
  value: string
  unit: string
  note: string
  icon: any
  details: boolean
  onClick: () => void
  timeStamp?: string
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent className={classes?.cardContent}>
        <Box
          display={'flex'}
          flexDirection={'row'}
          gap={1}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          {/* <Box className={classes?.icon}></Box> */}
          <Typography className={classes?.title}>{name}</Typography>

          {details ? (
            <IconButton className={classes?.openBtn} onClick={onClick}>
              <ChevronRightIcon htmlColor='#ffffff' />
            </IconButton>
          ) : null}
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'start'}
          alignItems={'center'}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            borderRadius={'50%'}
            height={90}
            width={90}
            className={classes?.cardIconContainer}
          >
            {icon}
          </Box>
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          //   justifyContent={'start'}
          //   alignItems={'center'}
        >
          <Typography className={classes?.subName}>{subName}</Typography>
          <Box display='flex' alignItems='center'>
            <Typography className={classes?.value}>{value}</Typography>
            <Typography className={classes?.unit}>&nbsp;{unit}</Typography>
          </Box>
          <Typography className={classes?.status}>{note}</Typography>
          {timeStamp && (
            <Tooltip title={timeStamp} placement='top-start'>
              <Typography className={classes?.status}>{timeStamp}</Typography>
            </Tooltip>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default VitalCard
